import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Gummy Browser · Your Privacy, Your Way</p>
        <h1>Experience the Web Like Never Before</h1>
        <p className="lede">
          Discover Gummy Browser, the web browser designed for enhanced privacy and a fully customizable user experience. Take control of your online journey today.
        </p>
        <div className="cta-row">
          <a href="/features" target="_blank">
            Explore Features
          </a>
          <a href="/download" target="_blank" className="secondary">
            Download Now
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Enhanced Privacy</h2>
          <p>
            Browse with confidence knowing your data is protected. Gummy Browser prioritizes your privacy with advanced security features.
          </p>
        </article>
        <article>
          <h2>Customizable Experience</h2>
          <p>
            Tailor your browsing experience to fit your needs. Choose themes, layouts, and extensions that enhance your productivity.
          </p>
        </article>
        <article>
          <h2>Seamless Performance</h2>
          <p>
            Enjoy fast and efficient browsing. Gummy Browser is optimized for speed, ensuring you get the best performance on every site.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;